<template>
    <div>
        <b-modal id="modal-Challenge" size="lg" class="modal-form" :title="modal_title" @hidden="CLEAR_FORM()" centered hide-footer>
            <ValidationObserver ref="form">
             
                <validation-provider rules="required" v-slot="{ errors }">
                    <div class="form-group">
                        <label>Challenge Name</label>
                        <input v-model="formdata.name" type="text" class="form-control" name="name">
                        <div class="invalid-input">{{ errors[0] }}</div>
                    </div>
                </validation-provider>

                <div class="row">
                    <div class="col-md-6">
                        <validation-provider rules="required" v-slot="{ errors }">
                            <div class="form-group">
                                <label>Start Date</label>
                                <datetime v-model="formdata.start_date" zone='local' value-zone='local' type="date" input-class="form-control"></datetime>
                                <div class="invalid-input">{{ errors[0] }}</div>
                            </div>
                        </validation-provider>
                    </div>
                    <div class="col-md-6">
                        <validation-provider rules="required" v-slot="{ errors }">
                            <div class="form-group">
                                <label>End Date</label>
                                <datetime v-model="formdata.end_date" zone='local' value-zone='local' type="date" input-class="form-control"></datetime>
                                <div class="invalid-input">{{ errors[0] }}</div>
                            </div>
                        </validation-provider>
                    </div>
                </div>

                <div class="form-group">
                    <label>Description</label>
                    <editor
                        v-model="formdata.desc"
                        :api-key="api_tiny"
                        :init="EditorOptions"
                    />
                </div>

                <div class="button-modal text-right">
                    <button v-on:click="validationForm(formdata.id)" type="button" class="btn btn-new" v-bind:class="loading ? 'btn-progress' : ''">
                        Save Data
                    </button>
                </div>
            </ValidationObserver>
        </b-modal>

        <b-modal id="modal-DetailChallenge" @show="_getParticipantRank()" size="xl" class="modal-form" title="Detail Challenge" @hidden="CLEAR_FORM()" centered hide-footer>
            
            <b-row class="mb-4 border-bottom pb-4">
                <b-col md="7">
                    <div class="pb-1"><strong>Name :</strong> {{formdata.name}}</div>
                    <div class="pt-1 pb-1"><strong>Achievement Type :</strong> {{formdata.achievement_type}}</div>
                    <div class="pt-1 pb-1"><strong>Status :</strong>
                        <label v-if="formdata.status === 'ON_PROGRESS'" class="badge badge-info">ON PROGRESS</label>
                        <label v-if="formdata.status === 'ON_SETUP'" class="badge badge-secondary">ON SETUP</label>
                        <label v-if="formdata.status === 'DONE'" class="badge badge-success">DONE</label>
                        <label v-if="formdata.status === 'WAITING'" class="badge badge-warning">WAITING</label>
                    </div>
                </b-col>
                <b-col md="5">
                    <div class="pb-1"><strong>Start Date :</strong> {{formdata.start_date | formatDate}}</div>
                    <div class="pt-1"><strong>End Date :</strong> {{formdata.end_date | formatDate}}</div>
                </b-col>
            </b-row>
            
            <div class="d-flex align-items-center mb-3">
                <div>
                    <h5 class="mb-0">Participant</h5>
                </div>
                <div class="ml-auto">
                    <button v-if="formdata.status !== 'DONE'" class="btn btn-secondary" v-b-modal.modal-Users @click="addUser()">Add User</button>
                </div>
            </div>

            <div class="table-responsive bdr-15">
                <table class="table table-striped">
                    <thead>
                        <tr>
                            <th>User</th>
                            <th>Event Total</th>
                            <th>Ranking</th>
                            <th v-if="formdata.status === 'DONE'">Achievement</th>
                            <th v-if="formdata.status !== 'DONE'"></th>
                        </tr>
                    </thead>
                    <tbody v-if="loading_participant === false">
                        <tr class="tr-ac" v-for="(data,index) in formdata.users" :key="data.id">
                            <td>
                                <div>{{data.name}}</div>
                                <small>{{data.email}}</small>
                            </td>
                            <td>
                                <template v-if="data.hasOwnProperty('iduser')">
                                    {{data.events_count}}
                                </template> 
                                <template v-if="!data.hasOwnProperty('iduser')">
                                    -
                                </template> 
                            </td>
                            <td>
                                <template v-if="data.hasOwnProperty('iduser')">
                                    {{parseInt(index) + 1}}
                                </template> 
                                <template v-if="!data.hasOwnProperty('iduser')">
                                    -
                                </template> 
                            </td>
                            <td v-if="formdata.status === 'DONE'">
                                <template v-if="data.achievement_id">
                                    {{data.achievement.name}}
                                </template> 
                                <template v-if="!data.achievement_id">
                                    -
                                </template> 
                            </td>
                            <td width="120px" v-if="formdata.status !== 'DONE'">
                                <button class="btn btn-danger" @click="deleteParticipant(data.id,index)"><i class="uil uil-times"></i></button>
                            </td>
                        </tr>
                    </tbody>
                </table>
                <div class="half-circle-spinner" v-if="loading_participant === true">
                    <div class="circle circle-1"></div>
                    <div class="circle circle-2"></div>
                </div>
            </div>

            <div class="d-flex align-items-center mb-3 mt-5">
                <div>
                    <h5 class="mb-0">Achievement</h5>
                </div>
                <div class="ml-auto">
                    <button v-if="formdata.status !== 'DONE'" class="btn btn-secondary" @click="addAchievement(formdata.name)">Add Achievement</button>
                </div>
            </div>

            <div class="table-responsive bdr-15 mb-4">
                <table class="table table-striped">
                    <thead>
                        <tr>
                            <th>Name</th>
                            <th>Rank</th>
                            <th v-if="formdata.status !== 'DONE'"></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr class="tr-ac" v-for="(data,index) in formdata.achievement" :key="data.id">
                            <td>
                                <div class="form-group mb-0" v-if="formdata.status !== 'DONE'">
                                    <input v-model="data.name" type="text" class="form-control" name="name">
                                </div>
                                <template v-if="formdata.status === 'DONE'">
                                    {{data.name}}
                                </template>
                            </td>
                            <th>
                                <div class="form-group mb-0" v-if="formdata.status !== 'DONE'">
                                    <input v-model="data.rank" type="number" class="form-control" name="name">
                                </div>
                                <template v-if="formdata.status === 'DONE'">
                                    {{data.rank}}
                                </template>
                            </th>
                            <td width="120px" v-if="formdata.status !== 'DONE'">
                                <button class="btn btn-danger" @click="deleteAchievement(data.id,index)"><i class="uil uil-times"></i></button>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <div class="button-modal text-right" v-if="loading_participant === false">
                <button v-if="formdata.users.length > 0 && formdata.achievement.length > 0" v-on:click="validationFormParticipant(formdata.id)" type="button" class="btn btn-primary btn-ex mr-3" v-bind:class="loading ? 'btn-progress' : ''">
                    Save Data
                </button>
                <button v-if="formdata.users.length > 0 && formdata.achievement.length > 0 && formdata.status === 'WAITING'" v-on:click="_statusChallenge('ON_PROGRESS')" type="button" class="btn btn-warning btn-ex" v-bind:class="loading ? 'btn-progress' : ''">
                    Start Challenge
                </button>
                <button v-if="formdata.users.length > 0 && formdata.achievement.length > 0 && formdata.status === 'ON_PROGRESS'" v-on:click="_statusChallenge('DONE')" type="button" class="btn btn-danger btn-ex" v-bind:class="loading ? 'btn-progress' : ''">
                    End Challenge
                </button>
            </div>
        </b-modal>

        <b-modal id="modal-Users" size="lg" class="modal-form" title="Add User Challenge" @hidden="CLEAR_SELECTED_USER()" centered hide-footer>

            <div class="row">
                <div class="col-md-3">
                    <div class="form-group">
                        <label>Tipe User</label>
                        <select class="form-control" v-model="filter_user.level" @change="addUser()">
                            <option value="3">AGENT</option>
                            <option value="2">DISTRIBUTOR</option>
                        </select>
                    </div>
                </div>
                <div class="col-md-3">
                    <div class="form-group">
                        <label>Tier User</label>
                        <select class="form-control" v-model="filter_user.tier" @change="addUser()">
                            <option value=""></option>
                            <option value="BRONZE">Bronze</option>
                            <option value="SILVER">Silver</option>
                            <option value="GOLD">Gold</option>
                            <option value="DIAMOND">Diamond</option>
                        </select>
                    </div>
                </div>
            </div>
                <div class="table-responsive">
                    <table class="table table-striped">
                        <thead>
                            <tr>
                                <th>User</th>
                                <th>Total Event</th>
                                <th>Tier</th>
                                <th>
                                    <div class="custom-control custom-checkbox">
                                        <input type="checkbox" class="custom-control-input" id="all_id_user" v-model="selectUser">
                                        <label class="custom-control-label" for="all_id_user"></label>
                                    </div>
                                </th>
                            </tr>
                        </thead>
                        <tbody v-if="loading_user === false">
                            <tr class="tr-ac" v-for="(data) in filteredTransportationParticipant" :key="data.id">
                                <td>
                                    <div>{{data.name}}</div>
                                    <small>{{data.email}}</small>
                                </td>
                                <td>{{data.events_count}}</td>
                                <td>{{data.tier}}</td>
                                <td width="100px" v-on:click.stop=""> 
                                    <div class="custom-control custom-checkbox">
                                        <input type="checkbox" class="custom-control-input" v-model="selected_user" :value="data" :id="data.id">
                                        <label class="custom-control-label" :for="data.id"></label>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <div class="half-circle-spinner" v-if="loading_user === true">
                        <div class="circle circle-1"></div>
                        <div class="circle circle-2"></div>
                    </div>
                </div>

                <div class="button-modal text-right">
                    <button v-on:click="addParticipant()" type="button" class="btn btn-new" v-bind:class="loading ? 'btn-progress' : ''">
                        Add User
                    </button>
                </div>
        </b-modal>
    </div>
</template>

<script>
    import { mapState, mapActions, mapMutations } from 'vuex'
    import {ValidationProvider, ValidationObserver} from "vee-validate";
    import options from "../../../utils/editor";
    import Editor from '@tinymce/tinymce-vue'
    import { Datetime } from 'vue-datetime';
    import moment from 'moment'

    export default{
        data(){
            return{
                api_tiny:process.env.VUE_APP_TINYKEY,
                EditorOptions: options.OptionsSimple,
                loading:false,
                modal_title : 'Add Challenge',
                photo_file:'',
                filter_user:{
                    level:'3',
                    tier:'',
                },
                selected_user:[],
                del_participant:[],
                del_achievement:[],
                loading_participant:false,
                loading_user:false,
            }
        },
        props: ['del_challenge'],
        components: {
            ValidationProvider,
            ValidationObserver,
            Editor,
            Datetime
        },
        filters: {
            formatDate: function(val){
                if(val){
                    return moment(String(val)).format('DD MMMM YYYY')
                }else{
                    return '-'
                }
            },
        },
        computed: {
            ...mapState('ChallengeControl', {
                formdata: state => state.formdata,
                errors: state => state.errors
            }),
            ...mapState('SelectControl', {
                participant: state => state.participant,
            }),

            selectUser: {
                get: function () {
                    return this.participant ? this.selected_user.length == this.participant.length : false;
                },
                set: function (value) {
                    var selected = [];

                    if (value) {
                        this.participant.forEach(function (user) {
                            selected.push(user);
                        });
                    }
                    this.selected_user = selected;
                }
            },

            filteredTransportationParticipant () {
                let filterParticipant = this.$store.getters['SelectControl/getFilteredParticipant'];
                return filterParticipant
            },
        },
        watch:{
            'formdata':function(val){
                if(val.id){
                    this.modal_title = 'Edit Challenge'
                }else if(!val.id){
                    this.modal_title = "Add Challenge"
                }
            },
        },
        methods: {
            ...mapActions('ChallengeControl', ['createChallenge','updateChallenge','updateChallengeParticipant','statusChallenge','getParticipantRank']),
            ...mapActions('SelectControl', ['getParticipant']),
            ...mapMutations('ChallengeControl', ['CLEAR_FORM']),
            
            filterTransportationParticipant:function() {
                this.$store.dispatch('SelectControl/filterTransportationParticipant', this.formdata )
            },
            addUser:function(){
                this.loading_user = true
                this.getParticipant(this.filter_user).then(() => {
                    this.filterTransportationParticipant()
                    this.loading_user = false
                })
            },
            addParticipant:function(){
                var vm = this
                this.selected_user.forEach(function (user) {
                    vm.formdata.users.push({
                        email:user.email,
                        events_count:user.events_count,
                        id:user.id,
                        name:user.name,
                        tier:user.tier,
                        user_id:user.id,
                    });
                });
                this.$bvModal.hide('modal-Users')
                this.selected_user = []
            },
            deleteParticipant:function(id,index){
                this.del_participant.push(id)
                this.formdata.users.splice(index,1)
            },
            addAchievement:function(){
                var num = this.formdata.achievement.length + 1
                this.formdata.achievement.push({
                    id : Math.random().toString(16).slice(2),
                    name : num +'st Winner '+ this.formdata.name,
                    rank : num
                });
            },
            deleteAchievement:function(id,index){
                this.del_achievement.push(id)
                this.formdata.achievement.splice(index,1)
            },
            _getParticipantRank:function(){
                this.loading_participant = true
                this.getParticipantRank().then(() => {
                    this.loading_participant = false
                }).catch((error) => {
                    console.log(error)
                    this.loading_participant = false
                })
            },
            validationForm: function(id) {
                this.$refs.form.validate().then(success => {
                    if (!success) {
                        setTimeout(() => {
                            const errors = Object.entries(this.$refs.form.errors)
                                .map(([key, value]) => ({ key, value }))
                                .filter(error => error["value"].length);
                            this.$refs.form.refs[errors[0]["key"]].$el.scrollIntoView({
                                behavior: "smooth",
                                block: "center"
                            });
                        }, 100);
                    }else{
                        this.loading = true

                        
                        if(id){
                            this.updateChallenge(this.formdata).then(() => {
                                this.loading = false
                                this.$bvModal.hide('modal-Challenge')
                                this.$emit('getChallenge');
                                this.CLEAR_FORM()
                                this.$toast.success('Successfully Update Challenge')
                            }).catch((error) => {
                                console.log(error)
                                this.loading = false
                                this.$toast.warning('Sorry, Something Error')
                            })

                        }else{

                            this.createChallenge(this.formdata).then(() => {
                                this.loading = false
                                this.$bvModal.hide('modal-Challenge')
                                this.$emit('getChallenge');
                                this.CLEAR_FORM()
                                this.$toast.success('Successfully Added Challenge')
                            }).catch((error) => {
                                console.log(error)
                                this.loading = false
                                this.$toast.warning('Sorry, Something Error')
                            })
                        }
                    }
                });
            },
            validationFormParticipant: function(id) {
                this.loading = true
                
                if(id){
                    this.formdata.del_participant = this.del_participant
                    this.formdata.del_achievement = this.del_achievement
                    this.updateChallengeParticipant(this.formdata).then(() => {
                        this.loading = false
                        this.$bvModal.hide('modal-DetailChallenge')
                        this.$emit('getChallenge');
                        this.CLEAR_FORM()
                        this.$toast.success('Successfully Update Challenge')
                    }).catch((error) => {
                        console.log(error)
                        this.loading = false
                        this.$toast.warning('Sorry, Something Error')
                    })

                }
            },
            _statusChallenge:function(sts){
                this.$swal({
                    title: 'Confirmation',
                    icon: 'warning',
                    text: "Are you sure change status challenge ? This action cannot be undone",
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonText: 'Yes',
                    cancelButtonText: 'Cancel'
                }).then((result) => {
                    if (result.value) {
                        this.statusChallenge({id:this.formdata.id,status:sts}).then(
                            this.$toast.success('Successfully Update Challenge'),
                            this.$bvModal.hide('modal-DetailChallenge'),
                            this.$emit('getChallenge')
                        )
                    }
                })
            }
        }
    }
</script>
